import Sloth from 'slothd/dist/Sloth';
import './table.scss';

@Sloth.component({
    defaultOptions:{
        option: 'option'
    }
})

export default class Table {
    onInit() {
        const dom = this.dom;

        $('.Table-more', dom).on('click', () => {
            if ($('.Table-body', dom).hasClass('Table-overhide')) {
                $('.Table-more', dom).text('收起');
                $('.Table-body', dom).removeClass('Table-overhide');
            } else {
                $('.Table-more', dom).text('展开');
                $('.Table-body', dom).addClass('Table-overhide');
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/Table/table.js
 **/